<template>
  <v-data-table
    :footer-props="footerProps"
    :headers="headers"
    :items="inscricoes"
    :options.sync="optionsModel"
    :server-items-length="totalItems"
    disable-sort
    class="mt-5 d-flex flex-grow-1 flex-shrink-0 flex-column"
    no-data-text="Nenhuma inscricão encontrada"
    :loading="loading"
    loading-text="Carregando inscrições..."
  >
    <template v-slot:item="{ item: inscricao, index }">
      <tr
        class="cvi-table-row"
        :key="inscricao.id"
        @click="$emit('onClick', inscricao, index)"
      >
        <td>
          <span class="d-flex align-center justify-center">
            {{ inscricao.posicao }}
          </span>
        </td>

        <td>
          {{ inscricao.protocolo }}
        </td>

        <td>
          {{ inscricao.matricula.codigo }}
        </td>

        <td>
          {{ inscricao.matricula.unidadeEnsino.nomeCompleto }}
        </td>

        <td>
          {{ inscricao.matricula.pessoa.nome }}
        </td>

        <td>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ma-0 d-flex justify-center"
                v-bind="attrs"
                v-on="on"
                :color="
                  inscricao.processo_judicial
                    ? 'green lighten-3'
                    : 'red lighten-3'
                "
                >{{
                  inscricao.processo_judicial
                    ? "mdi-thumb-up"
                    : "mdi-thumb-down"
                }}</v-icon
              >
            </template>
            <span>{{ inscricao.processo_judicial ? "SIM" : "NÃO" }}</span>
          </v-tooltip>
        </td>

        <td>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ma-0 d-flex justify-center"
                v-bind="attrs"
                v-on="on"
                :color="
                  inscricao.acolhimento_institucional
                    ? 'green lighten-3'
                    : 'red lighten-3'
                "
                >{{
                  inscricao.acolhimento_institucional
                    ? "mdi-thumb-up"
                    : "mdi-thumb-down"
                }}</v-icon
              >
            </template>
            <span>{{
              inscricao.acolhimento_institucional ? "SIM" : "NÃO"
            }}</span>
          </v-tooltip>
        </td>

        <td>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ma-0 d-flex justify-center"
                v-bind="attrs"
                v-on="on"
                :color="
                  inscricao.vulnerabilidade_social
                    ? 'green lighten-3'
                    : 'red lighten-3'
                "
                >{{
                  inscricao.vulnerabilidade_social
                    ? "mdi-thumb-up"
                    : "mdi-thumb-down"
                }}</v-icon
              >
            </template>
            <span>{{ inscricao.vulnerabilidade_social ? "SIM" : "NÃO" }}</span>
          </v-tooltip>
        </td>

        <td class="justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="getStatusConfig(inscricao.status).color"
                v-bind="attrs"
                v-on="on"
                >{{ getStatusConfig(inscricao.status).icon }}
              </v-icon>
            </template>
            <span>{{ getStatusConfig(inscricao.status).label }}</span>
          </v-tooltip>
        </td>

        <td>
          <v-chip
            class="d-flex justify-center"
            small
            outlined
            color="blue"
            text-color="blue"
          >
            {{
              inscricao.tipo === "TRANSFERENCIA" ? "Transferência" : "Cadastro"
            }}
          </v-chip>
        </td>

        <td v-if="isAdmin()">
          <span class="d-flex align-center justify-center">
            <v-icon color="red" @click.stop="$emit('excluir', inscricao)">
              mdi-delete
            </v-icon>
          </span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { isAdmin } from "@/plugins/security";

export default {
  name: "lista-cadastro",

  components: {},

  props: {
    inscricoes: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    items: {
      get() {
        return this.inscricoes;
      },
      set(value) {
        this.$emit("update:inscricoes", value);
      },
    },
    optionsModel: {
      get() {
        return this.options;
      },
      set(options) {
        this.$emit("update:options", options);
      },
    },
    footerProps() {
      return this.inscricoes.length
        ? {
            "items-per-page-options": [10, 25, 50, 100],
            "items-per-page-text": "Inscrições por página",
          }
        : {
            "disable-items-per-page": true,
            "disable-pagination": true,
            "items-per-page-text": "Inscrições por página",
          };
    },
    headers() {
      const headers = [
        { text: "Posição" },
        {
          text: "Protocolo",
          value: "protocolo",
          filter: (protocolo) =>
            !this.protocolo || protocolo.includes(this.protocolo),
        },
        {
          text: "Matrícula",
          value: "matricula.codigo",
          filter: (matricula) =>
            !this.matricula || matricula.includes(this.matricula),
        },
        {
          text: "Unidade",
          value: "matricula.unidadeEnsino.id",
          filter: (id) => !this.unidadeEnsino || id == this.unidadeEnsino.id,
        },
        {
          text: "Aluno",
          value: "matricula.pessoa.nome",
          filter: (aluno) => !this.aluno || aluno.includes(this.aluno),
        },
        {
          text: "Processo Judicial",
          value: "processo_judicial",
          filter: (processo_judicial) =>
            !this.processoJudicial || processo_judicial,
        },
        {
          text: "Acolhimento Institucional",
          value: "acolhimento_institucional",
          filter: (acolhimento_institucional) =>
            !this.acolhimentoInstitucional || acolhimento_institucional,
        },
        {
          text: "Vulnerabilidade Social",
          value: "vulnerabilidade_social",
          filter: (vulnerabilidade_social) =>
            !this.vulnerabilidadeSocial || vulnerabilidade_social,
        },
        {
          text: "Status",
          value: "status",
          filter: (status) => !this.status || status == this.status.value,
        },
        {
          text: "Tipo",
          value: "tipo",
          align: "center",
          filter: (tipo) => !this.tipo || tipo == this.tipo.value,
        },
      ];

      return this.isAdmin()
        ? [...headers, { text: "Cancelar Inscrição" }]
        : headers;
    },
  },

  methods: {
    isAdmin,

    getStatusConfig(status) {
      switch (status) {
        case "DEFERIDO":
          return { color: "green", icon: "mdi-check", label: "Deferido" };
        case "INDEFERIDO":
          return { color: "red", icon: "mdi-close", label: "Indeferido" };
        case "PENDENTE":
          return {
            icon: "mdi-minus",
            label: "Pendente",
          };
        case "DESISTENTE":
          return {
            icon: "mdi-account-off",
            color: "red",
            label: "Desistente",
          };
        case "ELIMINADO":
          return {
            color: "orange",
            icon: "mdi-account-remove",
            label: "Eliminado",
          };
      }
    },

    showDialogExclusao(inscricao) {
      this.$emit("excluir", inscricao);
    },
  },

  watch: {
    options() {
      this.$emit("input", this.options);
    },
  },
};
</script>

<style></style>
